<template>
    <div
        class="col-lg single-card single-card__video __has-border-full"
        :class="{'isTopRated': isTopRated, [getLayoutClass]: true}"
    >
        <div class="wrapper">
          <div class="content">
            <div class="figure-wrapper">
              <div class="figure-inner position-relative">
                <div v-if="isTopRated && video.video_id && !isSupplier" class="single-card__video-icon-view">
                    <icon-view />
                </div>
                <figure
                  role="button"
                  v-if="video.video_id"
                  @click="$bvModal.show(`modal-vimeo_${video.id}`)"
                >
                  <img loading="lazy" :src="getThumbnailVimeo(video.video_id)" :alt="video.title"
                    class="o-object-fit" />
                </figure>
                <figure
                 v-else-if="video.thumbnail"
                >
                  <img loading="lazy" :src="video.thumbnail.file.url" :alt="video.thumbnail.title" >
                </figure>
              </div>
            </div>
            <div class="desc">
              <p class="sup_title" v-if="video.category">{{ getCategoryNameById(video.category) }} | {{ video.partner }}</p>
              <h3 role="button" @click="$bvModal.show(`modal-vimeo_${video.id}`)">{{ video.title }}</h3>
              <p v-if="video.description">
                {{ video.description }}
              </p>
            </div>
          </div>

          <div class="single-card__footer">
            <b-button
              v-if="video.video_id"
              class="btn btn__inverted"
              :class="{'mb-3': video.media_link}"
              @click="$bvModal.show(`modal-vimeo_${video.id}`)"
            >
              {{ $t('watchNow') }}
            </b-button>
            <b-link
              v-if="video.media_link && !isSupplier"
              class="btn btn__inverted"
              :class="{'mb-3': video.cta_external_link}"
              target="_blank"
              :href="video.media_link.file.url"
            >
              {{ $t('dlInfoSheet') }}
            </b-link>
            <b-link
              v-if="video.media_link && isSupplier"
              class="btn btn__inverted"
              :class="{'mb-3': video.cta_external_link}"
              target="_blank"
              :href="video.media_link.file.url"
            >
              {{ $t('readMore') }}
            </b-link>
            <b-link
              v-if="video.cta_external_link"
              class="btn btn__inverted"
              target="_blank"
              :href="video.cta_external_link"
            >
              {{ $t('readMore') }}
            </b-link>
          </div>
        </div>
        <b-modal v-if="video.video_id" :id="`modal-vimeo_${video.id}`" size="xl" hide-footer centered :static="true"
          :lazy="false">
          <div class="embed-responsive embed-responsive-16by9">
            <vueVimeoPlayer class="embed-responsive-item" :video-id="video.video_id" :ref="`modal-vimeo_${video.id}`" />
          </div>
        </b-modal>
    </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'
import IconView from '../../icons/IconView.vue'

export default {
  name: 'VideoCard',
  components: {
    vueVimeoPlayer,
    IconView
  },
  props: {
    video: {
      type: Object,
      required: true
    },
    isTopRated: {
      type: Boolean,
      default: false
    },
    // props pour ajuster le style du composant pour les fournisseurs
    isSupplier: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLayoutClass () {
      return this.isSupplier ? 'col-lg-4 col-md-6 isSupplier' : 'col-lg-3 col-md-6'
    }
  },
  methods: {
    getThumbnailVimeo (videoId) {
      // easiest way to retrieve thumbnail of vimeo w/o BE
      return `https://vumbnail.com/${videoId}.jpg`
    },
    getCategoryNameById (id) {
      if (!id) return ''
      return this.$parent.getCategoryNameById(id)
    },
    play (videoPlayerRef) {
      if (this.$refs[videoPlayerRef]) this.$refs[videoPlayerRef].play()
    },
    pause (videoPlayerRef) {
      if (this.$refs[videoPlayerRef]) this.$refs[videoPlayerRef].pause()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
        setTimeout(() => {
          this.play(modalId)
        }, 1000)
      })
      this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
        this.pause(modalId)
      })
    })
  }
}
</script>

<style lang="scss">
.single-card__video {
  .wrapper {
    padding-bottom: 4rem;
  }

  &-icon-view {
      z-index: 1;
      position: absolute;
      top: -20px;
      right: -30px;
  }

  &.isTopRated {
      background-color: $green1-b2b;
      & > .wrapper {
          border-top:1px solid $green2-b2b;
          border-right:1px solid $green2-b2b;
          border-bottom:1px solid $green2-b2b;
      }
  }
  &.isSupplier {
    &:nth-child(3n+1) {
      .wrapper {
        border-left: 1px solid $green2-b2b;
      }
    }
  }
}
</style>
